var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9492 40C30.9668 40 39.8983 31.0458 39.8983 20C39.8983 8.9543 30.9668 0 19.9492 0C8.93153 0 0 8.9543 0 20C0 31.0458 8.93153 40 19.9492 40ZM29.1933 16.7678C30.1671 15.7915 30.1671 14.2086 29.1933 13.2322C28.2196 12.2559 26.6406 12.2559 25.6668 13.2322L17.4555 21.4645L14.2315 18.2322C13.2577 17.2559 11.6788 17.2559 10.7049 18.2322C9.73112 19.2085 9.73112 20.7915 10.7049 21.7677L15.6922 26.7677C16.6661 27.744 18.2449 27.744 19.2188 26.7677L29.1933 16.7678Z",
    fill: "#BBD148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircle);
export default __webpack_public_path__ + "static/media/check circle.459c619a32c0ce30d494dce14ebead4b.svg";
export { ForwardRef as ReactComponent };